export const handleChipColor = (up?: boolean, down?: boolean) => {
  if (up) {
    return '#E8F5E9'
  }
  if (down) {
    return '#FFF3C9'
  }
  return '#E5F2FF'
}
